export default "__VITE_ASSET__CvTHrBUm__"